import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const OverviewRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const OverviewCard = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
  }
`

export const IconCircle = styled.div<{ $borderColor: string }>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${vimovaTheme.colors.backgroundWarm};
  border: 1.5px solid ${({ $borderColor }) => $borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media print {
    width: 28px !important;
    height: 28px !important;
    border-radius: 50% !important;
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    border: 1.5px solid ${({ $borderColor }) => $borderColor} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const HeaderTextGroup = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const PeriodTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 16px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 16px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PeriodHours = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DbValueRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 8px 0;

  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 16px !important;
    margin: 8px 0 !important;
  }
`

export const DbValue = styled.div<{ $color: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.huge};
  color: ${({ $color }) => $color};
  text-align: center;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.huge} !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DbUnit = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};
  text-align: center;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatusBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 10px;
  background: ${vimovaTheme.colors.backgroundWarm};
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 8px;
  color: ${({ $color }) => $color};

  @media print {
    display: inline-flex !important;
    padding: 3px 12px !important;
    border-radius: 10px !important;
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 8px !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SourcesDivider = styled.div`
  height: 1px;
  background: ${vimovaTheme.colors.border};
  margin: 10px 0 8px 0;

  @media print {
    height: 1px !important;
    background: ${vimovaTheme.colors.border} !important;
    margin: 10px 0 8px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SourcesTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.primary};
  margin-bottom: 8px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SourceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-bottom: 8px !important;
  }
`

export const SourceLabel = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textLight};
  width: 44px;
  flex-shrink: 0;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textLight} !important;
    width: 44px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SourceBarTrack = styled.div`
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: ${vimovaTheme.colors.backgroundMuted};

  @media print {
    flex: 1 !important;
    height: 6px !important;
    border-radius: 3px !important;
    background: ${vimovaTheme.colors.backgroundMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SourceBarFill = styled.div<{ $width: number; $color: string }>`
  height: 6px;
  border-radius: 3px;
  background: ${({ $color }) => $color};
  width: ${({ $width }) => $width}%;

  @media print {
    height: 6px !important;
    border-radius: 3px !important;
    background: ${({ $color }) => $color} !important;
    width: ${({ $width }) => $width}% !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SourceValue = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 8px;
  color: ${vimovaTheme.colors.primary};
  width: 36px;
  text-align: right;
  flex-shrink: 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 8px !important;
    color: ${vimovaTheme.colors.primary} !important;
    width: 36px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScaleCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;
  margin-top: 16px;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    margin-top: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScaleTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.primary};
  margin-bottom: 10px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScaleBarWrapper = styled.div`
  position: relative;
  padding-top: 28px;
  margin-bottom: 8px;

  @media print {
    position: relative !important;
    padding-top: 28px !important;
    margin-bottom: 8px !important;
  }
`

export const ScaleBar = styled.div`
  height: 14px;
  border-radius: 7px;
  background: linear-gradient(
    to right,
    ${vimovaTheme.colors.green} 0%,
    ${vimovaTheme.colors.green} 40%,
    ${vimovaTheme.colors.orange} 60%,
    #c0392b 80%,
    ${vimovaTheme.colors.primary} 100%
  );

  @media print {
    height: 14px !important;
    border-radius: 7px !important;
    background: linear-gradient(
      to right,
      ${vimovaTheme.colors.green} 0%,
      ${vimovaTheme.colors.green} 40%,
      ${vimovaTheme.colors.orange} 60%,
      #c0392b 80%,
      ${vimovaTheme.colors.primary} 100%
    ) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScaleMarker = styled.div<{ $position: number; $color: string }>`
  position: absolute;
  left: ${({ $position }) => $position}%;
  bottom: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;

  @media print {
    position: absolute !important;
    left: ${({ $position }) => $position}% !important;
    bottom: 0 !important;
    transform: translateX(-50%) !important;
  }
`

export const MarkerBadge = styled.div<{ $color: string }>`
  padding: 1px 8px;
  border-radius: 6px;
  background: ${({ $color }) => $color};
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 7px;
  color: ${vimovaTheme.colors.white};
  white-space: nowrap;
  margin-bottom: 2px;

  @media print {
    padding: 1px 8px !important;
    border-radius: 6px !important;
    background: ${({ $color }) => $color} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 7px !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MarkerLine = styled.div<{ $color: string }>`
  width: 2px;
  height: 22px;
  background: ${({ $color }) => $color};

  @media print {
    width: 2px !important;
    height: 22px !important;
    background: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ScaleLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    margin-top: 4px !important;
  }
`

export const ScaleNumber = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 7px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ReferenceRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    margin-top: 8px !important;
  }
`

export const ReferenceItem = styled.div`
  text-align: left;

  @media print {
    text-align: left !important;
  }
`

export const ReferenceName = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textLight};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ReferenceDb = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 7px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 7px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  flex: 1;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
    flex: 1 !important;
  }
`

export const MapCard = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;
  display: flex;
  flex-direction: column;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    display: flex !important;
    flex-direction: column !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    margin-bottom: 10px !important;
  }
`

export const MapTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapDbBadge = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 9px;
  background: ${({ $color }) => $color};
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 8px;
  color: ${vimovaTheme.colors.white};

  @media print {
    display: inline-flex !important;
    padding: 3px 10px !important;
    border-radius: 9px !important;
    background: ${({ $color }) => $color} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 8px !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapPlaceholder = styled.div<{ $noiseColor: string }>`
  flex: 1;
  min-height: 200px;
  border-radius: ${vimovaTheme.borderRadius.small};
  background: ${vimovaTheme.colors.backgroundWarm};
  border: 1px solid ${vimovaTheme.colors.border};
  position: relative;
  overflow: hidden;

  @media print {
    flex: 1 !important;
    min-height: 200px !important;
    border-radius: ${vimovaTheme.borderRadius.small} !important;
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MapPlaceholderText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};
  text-align: center;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
